import React from 'react';
import { Box, Button, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import { whatsAppHref } from '../constants/conversion';
import WhatsAppBrandIcon from './WhatsAppBrandIcon';

export default function ConversionLeadBar() {
  const theme = useTheme();
  const narrow = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      component="nav"
      aria-label="Quick contact"
      sx={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9998,
        py: 1,
        px: 1.5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5,
        flexWrap: 'wrap',
        background: 'rgba(18, 19, 58, 0.96)',
        borderTop: '1px solid rgba(255,255,255,0.08)',
        boxShadow: '0 -2px 16px rgba(15, 23, 42, 0.12)',
      }}
    >
      {!narrow && (
        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)', fontWeight: 600, mr: 1 }}>
          Need software, AI, or training?
        </Typography>
      )}
      <Button
        component={Link}
        to="/request-quote"
        variant="contained"
        color="secondary"
        size="small"
        sx={{ fontWeight: 700, textTransform: 'none', color: 'primary.main' }}
      >
        Free scope
      </Button>
      <Button
        component="a"
        href={whatsAppHref('Hi Boldcomp — I am on your website.')}
        target="_blank"
        rel="noopener noreferrer"
        variant="contained"
        size="small"
        className="wa-soft-blink"
        startIcon={<WhatsAppBrandIcon sx={{ fontSize: 20 }} />}
        sx={{
          bgcolor: '#25D366',
          color: 'white',
          fontWeight: 700,
          textTransform: 'none',
          boxShadow: 'none',
          '&:hover': { bgcolor: '#20bd5a', boxShadow: '0 2px 12px rgba(37,211,102,0.4)' },
        }}
      >
        WhatsApp
      </Button>
      <Button
        component={Link}
        to="/contact"
        variant="text"
        size="small"
        sx={{ color: 'rgba(255,255,255,0.85)', fontWeight: 600, textTransform: 'none' }}
      >
        Contact
      </Button>
    </Box>
  );
}
